<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure>
                          <icon name="truck-01" v-if="resource.type=='delivery'"/>
                          <icon name="package" v-else-if="resource.type=='shipping'"/>
                          <icon name="marker-pin-04" v-else/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Shipping <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>

                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                      <notice-published v-model="resource" label-published="Ce produit est actif." label-unpublished="Ce produit est inactif."></notice-published>

                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">


                              <fieldset>

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <div class="selector">
                                  <label @click="selectType('delivery')" v-bind:class="{'active':resource.type=='delivery'}">
                                    <icon name="truck-01"/>
                                    <span>
                                        <strong>Livraison</strong>
                                        <p>Livraison à domicile</p>
                                    </span>
                                  </label>
                                  <label @click="selectType('shipping')" v-bind:class="{'active':resource.type=='shipping'}">
                                    <icon name="package"/>
                                    <span>
                                        <strong>Expédition</strong>
                                        <p>Expédition à domicile via transporteur</p>
                                    </span>
                                  </label>
                                  <label @click="selectType('pickup')" v-bind:class="{'active':resource.type=='pickup'}">
                                    <icon name="marker-pin-04"/>
                                    <span>
                                        <strong>Retrait</strong>
                                        <p>Retrait en magasin</p>
                                    </span>
                                  </label>
                                </div>

                              </fieldset>

                              <fieldset>
                                <h3>Détail de la livraison</h3>
                                <p class="headline"></p>

                                <form-select-new label="Succursale" hint="Laisser vide si la livraison est globale à votre acivité" multiple="false" v-model="resource.branch" :options="branches" v-if="branches"></form-select-new>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id"  :label="'name'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-text :translate-key="'headline'" :translations="resource.translations" :lang="client.id" :label="'headline'" v-model="resource.translations[client.id].headline" :required="true"></form-text>
                                  </div>
                                </div>

                                <div class="form-multilang" v-if="localesLoaded" :class="locale">
                                  <div v-for="client in locales" v-show="client.id == locale || locale == 'all'">
                                    <form-textarea :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description"></form-textarea>
                                  </div>
                                </div>

                                <group-line-2>
                                  <form-number :label="price" v-model="resource.cost_global" :suffix="currency" :required="true"></form-number>
                                  <form-select label="Taxe" multiple="false" v-model="resource.tax" :default="resource.tax_id" :options="$store.state.taxes" :required="true"></form-select>
                                </group-line-2>


                                <div v-if="resource.type!='pickup'">
                                  <form-number label="Distance maximum de livraison" hint="La livraison est conditionnelle à une adresse cliente située dans une zone définie ; laisser vide si non utilisée." v-model="resource.radius_distance_meters" suffix="mètres" v-if="resource.type=='delivery'"></form-number>
                                  <form-countries label="Pays" multiple="true" v-model="resource.countries" :required="true"></form-countries>
                                  <form-select label="Transporter" multiple="false" v-model="resource.transporter" :options="transporters" v-if="transporters && resource.type=='shipping'"></form-select>
                                </div>

                                <form-toggle label="Demander la sélection d'un horaire de livraison / retrait" v-model="resource.display_delivery_schedules"></form-toggle>
                                <form-toggle label="Afficher les délais de livraison au client" v-model="resource.display_deadlines_to_customer"></form-toggle>

                                <form-numeric label="Order d'affichage sur votre site" v-model="resource.ord"></form-numeric>

                              </fieldset>

                              <fieldset>
                                <h3>Traitement des commandes</h3>
                                <p class="headline">Définissez à quel moment vous traitez une commande client</p>

                                <form-condition v-model="resource.use_opening_hours" :options="schedules" :required="true">
                                  <template v-slot:vrai>

                                  </template>
                                  <template v-slot:faux>
                                    <form-number label="Heure limite de commande" v-model="resource.order_time_limit" suffix="heures" hint="Indique jusqu'à quelle heure une commande peut être passée afin d'être traitée le jour même."></form-number>
                                  </template>
                                </form-condition>

                              </fieldset>

                              <fieldset>
                                <h3>Estimation du temps de livraison</h3>
                                <p class="headline"></p>

                                <group-line-2>
                                  <form-number label="Durée minimum estimée" v-model="resource.duration_estimate_min" suffix="minutes" :required="true"></form-number>
                                  <form-number label="Durée maximum estimée" v-model="resource.duration_estimate_max" suffix="minutes" :required="true"></form-number>
                                </group-line-2>

                                <form-number label="Durée maximale acceptable de transport" v-model="resource.duration_max" suffix="minutes" hint="Principalement utilisé pour les marchandises périssables. Si suéprieur à zéro, le système cherchera le meilleur moment pour l'expédition pour limiter le temps durant le transport."></form-number>

                              </fieldset>


                            </tab>
                            <tab name="Conditions">

                              <fieldset>
                                <h3>Conditions d'application de la promotion</h3>
                                <p class="headline"></p>

                                <component-conditions v-model="resource.conditions" :options="options_default"></component-conditions>

                              </fieldset>

                            </tab>
                          <tab name="Debug">

                            <fieldset>

                              <h3>Tests de commandes</h3>
                              <p class="headline">Permet de valider votre configuration sur l'estimation et les délais appliqués lors d'une commande.</p>

                              <button @click="debugConfiguration()"><span>Tester maintenant</span></button>

                              <div>
                                <div v-for="item in debug" style="margin-bottom: 10px;">
                                  <div>

                                    <h2>Commande passée le <datetime v-model="item.order_date" :human="false"></datetime> (heure locale)</h2>

                                    <div v-if="item.success == true">
                                      <span v-if="item.same_day" style="color: blue;display:block;font-weight:bold;">--> Expédition possible le jour même</span>
                                      <span style="display:block;">--> Expédition planifiée selon horaire limite <datetime v-model="item.shipping_date_info" :human="false"></datetime></span>
                                      <span style="display:block;">--> Expédition planifiée selon horaire ouverture le <datetime v-model="item.shipping_date_openinghours" :human="false"></datetime></span>
                                      <br>
                                      <span style="display:block;font-weight: bold;">--> Expédition planifiée le <datetime v-model="item.shipping_date" :human="false"></datetime></span>
                                      <span style="display:block;font-weight: bold;color:orange;" v-if="item.iteration > 0">--> Expédition modifiée {{ item.iteration > 1 ? item.iteration + "x" : ''}} à cause de la durée de transport</span>
                                      <br>
                                      <span>--> Réception estimée au <schedule :start-at="item.delivery_min_date" :end-at="item.delivery_max_date"></schedule></span><br>
                                      <span style="color: blue;">--> Durée du transport ~ {{ item.average_transport_duration/60 }} heure(s)</span>
                                      <br><br>
                                      <div style="overflow: auto;max-height: 200px;">
                                        <div v-for="(schedule, index) in item.delivery_schedules" style="margin-bottom: 1em;">
                                          <h3>{{ index }}</h3>
                                          <span v-for="elm in schedule" style="display: inline-block; padding: 5px; background: #ddd;margin: 2px;"><i class="icon icon-icon_clock"></i> {{ getScheduleTime(elm[0]) }} - {{ getScheduleTime(elm[1]) }}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div v-else style="color: red;">
                                      Votre méthode de livraison n'est pas possible, veuillez vérifier la configuration du temps de transport, l'heure limite (si définie) ou encore les horaires de votre succursale (si définie). Un onglet DEBUG est à votre disposition pour vos tests.
                                    </div>

                                  </div>
                                </div>
                              </div>

                            </fieldset>

                          </tab>
                        </tabs>

                    </main>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import TransporterService from '../../config/transporter/TransporterService.js';
    import ShippingService from './ShippingService.js';
    import Edit from '../../../layouts/Edit.vue';
    import ComponentConditions from "../../../components/Conditions.vue";
    import BranchService from "../../config/branch/BranchService";

    export default {
        extends: Edit,
        components: {
            'component-conditions': ComponentConditions
        },
        data () {
            return {
                resource: {
                },
                schedules: [
                  {id: 1, slot:'vrai', name: 'Durant les horaires d\'ouverture', description: 'Les commandes passées sont traitées durant les horaires d\'ouverture de la succursale. Si une commande est passée hors de vos horaires, le système sélectionnera automatiquement le prochain créneau disponible pour le traitement / l\'expédition de celle-ci.'},
                  {id: 0, slot:'faux', name: 'Le jour même ou le prochain jour ouvré', description: 'Seules les commandes passées jusqu\'à une heure spécifique sont traitées le jour même. Une fois l\'heure dépassée, le système sélectionnera automatiquement le prochain jour ouvré.'}
                ],
                options: [],
                isLoading: false,
                conditions: [],
                debug: [],
                branches: null,
                currency: '',
                price: '',
                transporters: [],
                options_default: [
                    {
                        id:"country",
                        name: "Pays",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'in', name:'in (..., ...)'},
                            {id:'contain', name:'contains'}
                        ]
                    },
                    {
                        id:"subtotal",
                        name: "Sous-total HT",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='}
                        ]
                    },
                    {
                        id:"totalPackageWeight",
                        name: "Poids en grammes",
                        operators:[
                            {id:'egal', name:'='},
                            {id:'greater_than', name:'>'},
                            {id:'egal_greater_than', name:'>='},
                            {id:'less_than', name:'<'},
                            {id:'egal_less_than', name:'<='},
                            {id:'not_egal', name:'!='},
                            {id:'in', name:'in (..., ...)'}
                        ]
                    },
                    {
                      id:"storageTemperature",
                      name: "Température de conservation (°C)",
                      operators:[
                        {id:'egal', name:'='},
                        {id:'greater_than', name:'>'},
                        {id:'egal_greater_than', name:'>='},
                        {id:'less_than', name:'<'},
                        {id:'egal_less_than', name:'<='},
                        {id:'not_egal', name:'!='}
                      ]
                    }
                ]
            }
        },
        mounted: function(){
            this.currency = this.$store.state.scope.currency_id
            this.price = 'Prix ' + (this.$store.state.scope.is_ttc?'TTC':'HT')

            TransporterService.all().then(response => {
                this.transporters = response.data
                this.isLoading = false
                for(let item of response.data){
                    if( item.id == this.resource.transporter_id ){
                        this.resource.transporter = item;
                        break;
                    }
                }
            })

            BranchService.query().then(response => {
              this.branches = response.data.data;
              this.isLoading = false
            });
        },
        methods:{
          getScheduleTime: function(str)
          {
            const dateString = str;
            const dateObj = new Date(dateString);

            const heures = dateObj.getHours().toString().padStart(2, '0');
            const minutes = dateObj.getMinutes().toString().padStart(2, '0');

            return `${heures}:${minutes}`;
          },
            resourceLoaded: function(){
                this.setTranslations(['name','headline','description']);
                this.resource.conditions = this.resource.conditions||[];
                this.resource.branch_id = this.resource.branch_id || null;
                this.resource.branch = this.resource.branch || this.resource.branch_id;

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/

                this.initialize()
            },
            beforeUpdate: function(Resource){
                return true;
            },
            selectType: function(type)
            {
              this.resource.type = type;
              this.$forceUpdate()
            },
            getResource: function(){
                return ShippingService
            },
            limitText (count) {
                return `and ${count} other countries`
            },
            asyncFind (query) {
                this.isLoading = true
                ShippingService.query('?query=' + query ).then(response => {
                    this.isLoading = false
                })
            },
            clearAll () {

            },
            debugConfiguration () {
              if( this.resource.duration_estimate_min != null && this.resource.duration_estimate_max != null && this.resource.order_time_limit != null )
              {
                ShippingService.check({
                  type: this.resource.type,
                  duration_max: this.resource.duration_max,
                  duration_estimate_min: this.resource.duration_estimate_min,
                  duration_estimate_max: this.resource.duration_estimate_max,
                  order_time_limit: this.resource.order_time_limit,
                  use_opening_hours: this.resource.use_opening_hours,
                  branch_id: this.resource.branch.id
                }).then(response => {
                  this.isLoading = false
                  this.debug = response.data;
                })
              }
            }
        },
      watch: {
        'resource': {
          handler: function (val, oldVal) {

          },
          deep: true
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/shipping/Edit.vue